import MainHome from "./001-Main-Home";
import LandingPage from "@/components/LandingPage/LandingPage";

export default function Home() {
  return (
    <>
      <main className="">
        <LandingPage />
      </main>
    </>
  );
}
